import axiosInstance from "./axiosInstance";

const apiUrl = process.env.REACT_APP_API_URL;

export const fetchLogReports = async (cmpid) => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/api/get_all_apilogs/?cmptransid=${cmpid}`,
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch logs:", error);
    return [];
  }
};
